var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconoProcesos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 127,
    viewBox: "0 0 114 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107 17.95V27.85C107 37.0398 103.313 45.8531 96.7487 52.3513C90.185 58.8494 81.2826 62.5 72 62.5H67V67.45H92V102.1C92 104.726 90.9464 107.244 89.0711 109.1C87.1957 110.957 84.6522 112 82 112H42C39.3478 112 36.8043 110.957 34.9289 109.1C33.0536 107.244 32 104.726 32 102.1V67.45H57V52.6C57 43.4103 60.6875 34.5969 67.2513 28.0988C73.815 21.6006 82.7174 17.95 92 17.95H107ZM29.5 13C35.4999 12.9952 41.4131 14.4176 46.7418 17.1475C52.0705 19.8774 56.6587 23.8348 60.12 28.6866C54.8368 35.56 51.9836 43.9628 52 52.6V57.55H49.5C39.5544 57.55 30.0161 53.6386 22.9835 46.6763C15.9509 39.7141 12 30.2712 12 20.425V13H29.5Z",
    fill: "#164453"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoProcesos);
export default __webpack_public_path__ + "static/media/icono_procesos.fff9b0ba8d794776926146979077f537.svg";
export { ForwardRef as ReactComponent };